// extracted by mini-css-extract-plugin
export default {"wrapperClass":"E9Pj6_q2hH_yxJY_62A0"};